export default __webpack_public_path__ + "static/media/emailIcon.921d0a35.png";